import { ChangeDetectorRef, Component } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { Customer } from '../../interfaces/interfaces';

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.scss']
})
export class CustomersComponent extends SimpleTableComponent<Customer> {
    constructor(
        private apiServiceRef: ApiService,
        private changeDetectionRef: ChangeDetectorRef
    ) {
        super(changeDetectionRef, apiServiceRef);
        this.endPoint = 'customers';
    }
}
